import { Component, Input, OnInit } from '@angular/core';
import { Icon } from '@types-custom/models/ui/icon-model';
import { IDynamicSideMenuModel } from '@types-custom/models/ui/dynamic-side-menu';
import { BehaviorSubject, Observable } from 'rxjs';
import { delay, tap } from 'rxjs/operators';
import { ToastService } from "@ui-core/services/toast/toast.service";
import { PanelStateService } from "@shared/services/panel-management/panel-management.service";

/*
 ** Dynamic Side Menu
 ** Render a side menu that allows you to show data based on a specified model.
 */
@Component({
  selector: 'dynamic-side-menu',
  templateUrl: './dynamic-side-menu.component.html',
  styleUrls: ['./dynamic-side-menu.component.scss'],
})
export class DynamicSideMenuComponent implements OnInit {
  @Input() properties: BehaviorSubject<IDynamicSideMenuModel> | undefined;
  isComponentVisible = new BehaviorSubject<boolean>(false);
  isSubcomponentVisible = new BehaviorSubject<boolean>(false);
  Icon = Icon;

  constructor(
    public ToastService: ToastService,
    public sideMenuService: PanelStateService
  ) {
  }

  ngOnInit(): void {
    this.sideMenuService.setSubpanelState(null);
    if (this.properties) {
      this.properties
        .pipe(
          tap(() => this.ToastService.isComponentVisible$.next(false)),
          delay(10)
        )
        .subscribe(this.handlePropertiesUpdate.bind(this));
    }
  }

  handlePropertiesUpdate(props: IDynamicSideMenuModel): void {
    if (props.content) {
      this.ToastService.isComponentVisible$.next(true);
    }

    const subpanel = props.subcontent;

    if (subpanel && subpanel?.component) {
      this.sideMenuService.setSubpanelState({
        component: subpanel.component,
        data: subpanel?.data ?? null,
      })
    }
    else this.sideMenuService.updateSubpanelData(null);
  }

  toggleMenu(seccondary: boolean = false): void {
    // this.sideMenuService.updateSubpanelData(null);

    if (seccondary) { // Si se llama desde el subpanel
      this.sideMenuService.updateSubpanelData(null);
      // this.mapService.clearMap();
    } else if (this.properties?.value.toggleDispatcher$) {
      const {
        properties: {
          value: { toggleDispatcher$ },
        },
      } = this;
      const isVisible = toggleDispatcher$.value;
      this.ToastService.isComponentVisible$.next(!isVisible);
      toggleDispatcher$.next(!isVisible);
    }
  }

  disableClickDispatcher() {
    this.properties.value.content.data.properties?.clickInteractionDispatcher?.next(
      undefined
    );
  }
}
